import React, { Component } from 'react';
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../../configuration";
import moment from "moment";


const ImageView = (props) => {
    if (props.imagePath) {
        return <img className="cart-item-preview-image" alt="" src={props.imagePath}/>
    } else {
        return <span>X</span>
    }
};

class OrderItemProductionStatus extends Component {
    constructor(props){
        super(props);
        this.state = {
            productionStatus : []
        };
        this.getOrderProductionStatus = this.getOrderProductionStatus.bind(this);
    }

    componentDidMount() {
        // console.log("ORDER UUID ===> ", this.props.orderItem.orderUUID);

        this.props.orderItem.orderUUID != null ? this.getOrderProductionStatus(this.props.orderItem.orderUUID) : "";

    }
    getOrderProductionStatus = (orderUUID) => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/jlcpcb/order/production/status/' + orderUUID+'/'+this.props.orderId, axiosConfig)
            .then((res) => {
                // console.log("rest",res.data);
                this.setState({
                    productionStatus: res.data.result.wipProcesses
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                axios.get(RESOURCE_BASE_URL + 'api/item/production/status/' + orderUUID+'/'+this.props.orderId, axiosConfig)
                    .then((res) => {
                        this.setState({
                            productionStatus: res.data.result.wipProcesses
                        });
                    })
                    .catch((err) => {
                        console.log("[API] ERROR: ", err);


                    });

            });
    };

    render(){
        let offset = new Date().getTimezoneOffset();
        // console.log("ITEMMMM ===> ", this.state.productionStatus);
        let item = this.props.orderItem;

        let beginTime = "現在データはありません";
        let endTime = "現在データはありません";
        let technicsProcessName = "現在データはありません";
        /*if(this.state.productionStatus != null){
            if(this.state.productionStatus.result != null || this.state.productionStatus.result != undefined){
                beginTime = this.state.productionStatus.result.beginTime;
                endTime = this.state.productionStatus.result.endTime;
                technicsProcessName = this.state.productionStatus.result.technicsProcessName;
            }
        }*/



        return(
            <div>
            <div className="col-md-12 tracking-item-row">
                            <div >
                                <div className="col-md-2 custom-col-2 no-padding-left resp-tracking-item">{item.barcode}</div>
                                <div className="col-md-3 custom-col-3 no-padding resp-tracking-item">
                                    <ImageView imagePath ={item.imageUrlFront}/>
                                </div>

                                {/**--uncomment this for production progress--*/}

                                <div className="col-md-7 custom-col-7">
                                    {this.state.productionStatus!= null && this.state.productionStatus!= undefined && this.state.productionStatus.length!== 0 ?

                                            this.state.productionStatus.map(processItem => {

                                               return <div className="row">
                                                   {processItem.beginTime!==null ?
                                                       <div className="col-md-6 custom-col-6">{processItem.beginTime.substring(0,4)}年{processItem.beginTime.substring(5,7)}月{processItem.beginTime.substring(8,10)}日
                                                           &nbsp;{processItem.beginTime.substring(11,19)}
                                                       </div>:
                                                       <div className="col-md-6 custom-col-6">{beginTime}</div>
                                                   }
                                                    <div className="col-md-4 custom-col-4">

                                                        {processItem.technicsProcessName === "MI" ?
                                                            <text>材料投入</text> :
                                                            processItem.technicsProcessName === "Inner Layer" ?
                                                                <text>積層</text> :
                                                            processItem.technicsProcessName === "Print" ?
                                                                <text>最終印刷</text> :
                                                                processItem.technicsProcessName === "Lamination" ?
                                                                    <text>ラミネート</text> :
                                                                processItem.technicsProcessName === "Delivery" ?
                                                                    <text>出荷準備中</text> :
                                                                    processItem.technicsProcessName === "Shipping to Hong Kong transit point" ?
                                                                        <text>香港中継点へ出荷</text> :
                                                                        processItem.technicsProcessName === "Arrive at Hong Kong transit point" ?
                                                                            <text>香港中継点に到着</text> :
                                                                            processItem.technicsProcessName === "Drilling" ?
                                                                                <text>穴あけ</text> :
                                                                                processItem.technicsProcessName === "Copper Deposition" ?
                                                                                    <text>化学メッキ</text> :
                                                                                    processItem.technicsProcessName === "Image the outer layers" ?
                                                                                        <text>露光・現像</text> :
                                                                                        processItem.technicsProcessName === "Pattern Plating" ?
                                                                                            <text>回路形成</text> :
                                                                                            processItem.technicsProcessName === "Automatic Optical Inspection(AOI)" ?
                                                                                                <text>中間検査</text> :
                                                                                                processItem.technicsProcessName === "Automatic Visual Inspection" ?
                                                                                                    <text>外観検査</text> :
                                                                                                    processItem.technicsProcessName === "Solder Mask" ?
                                                                                                        <text>レジスト印刷</text> :
                                                                                                        processItem.technicsProcessName === "Silkscreen" ?
                                                                                                            <text>シルク印刷</text> :
                                                                                                            processItem.technicsProcessName === "Hot Air Solder Leveling(HASL)" ?
                                                                                                                <text>表面処理</text> :
                                                                                                                processItem.technicsProcessName === "Electrical Test" ?
                                                                                                                    <text>導通検査</text> :
                                                                                                                    processItem.technicsProcessName === "Profiling,V-cut scoring" ?
                                                                                                                        <text>外形加工・Vカット</text> :
                                                                                                                        processItem.technicsProcessName === "Final inspection" ?
                                                                                                                            <text>最終検査</text> :
                                                                                                                            processItem.technicsProcessName === "Package" ?
                                                                                                                                <text>梱包</text> :
                                                                                                                                processItem.technicsProcessName === "shipped" ?
                                                                                                                                    <text>出荷完了</text> : <text>{processItem.technicsProcessName}</text>

                                                        }
                                                    </div>
                                                </div>
                                            }):
                                            <div className="row">
                                                <div className="col-md-6 custom-col-6">{beginTime}</div>
                                                <div className="col-md-5 custom-col-5">{technicsProcessName}</div>
                                            </div>

                                            }

                                </div>

                                {/**----------------------------------*/}

                            </div>

            </div>
            <hr/>
            </div>
        );
    }

}
export default OrderItemProductionStatus;



// WEBPACK FOOTER //
// ./src/components/Admin/Order/ViewAllOrders/OrderTableRow/OrderItemProductionStatus/OrderItemProductionStatus.js